import React from "react";
import { List, ListItem } from "@mui/material";
import AuctionCard from "@/components/ui/AuctionCard";
import { AuctionTypeEnum } from "@/lib/utils/AuctionTypeEnum";
import { AuctionLotStatusEnum } from "@/lib/utils/AuctionLotStatusEnum";
import useHistory from "../../lib/hooks/useHistory";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/Store";
import { getNewDateWithOffset } from "prembid-shared-library-npm/helpers"
import { clearFilterObjectData, clearLotViewType } from "../../pages/Lots/store/Lots";
import { GeneralPopper } from "../composite/popper/GeneralPopper";

interface Props {
    imgSrc: string;
    header: string;
    description: string;
    startDateTimeAt: any;
    endDateTimeAt: any;
    auctionEndDateTimeAt?: any,

    successBadgeText: number;
    dangerBadgeText?: string;

    auctionType: string;
    hasExtensions: boolean;
    hasBadge?: boolean;
    hasDeposit?: boolean;
    settings: any;

    infoBadgeText?: string,

    btnText?: string;
    btnSrc?: string;
}

const AuctionStackedCard: React.FC<Props> = (props) => {
    const history = useHistory();
    const dispatch = useDispatch();

    const {
        imgSrc,
        header,
        description,
        startDateTimeAt,
        endDateTimeAt,
        auctionEndDateTimeAt,

        successBadgeText,
        dangerBadgeText,

        auctionType,
        hasExtensions,
        hasBadge = false,
        hasDeposit = false,
        settings,
        infoBadgeText,

        btnText,
        btnSrc,
    } = props;

    const currentDateTimeOffset = useSelector((state: RootState) => state.settings.serverDateTimeDifference);

    const [anchorEl, setAnchorEl] = React.useState(null);

    const now = getNewDateWithOffset(currentDateTimeOffset);
    const start = new Date(startDateTimeAt);
    const end = new Date(endDateTimeAt);


    const btnRoute = () => {
        if (btnSrc) {
            dispatch(clearLotViewType(settings.DefaultLotView));
            dispatch(clearFilterObjectData());
            history.push(btnSrc);
        }
    }

    const handleInfoPopperClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleInfoPopperClose = () => {
        setAnchorEl(null);
    };

    const getInfoElement = () => {
        const placeholderText = Number(auctionType) === Number(AuctionTypeEnum.Tender) ? "tender" : "bid";
        const placeholderActioningText = Number(auctionType) === Number(AuctionTypeEnum.Tender) ? "tendering" : "bidding";

        let auctionStatus = AuctionLotStatusEnum.Awaiting;

        if (now < start) auctionStatus = AuctionLotStatusEnum.Awaiting;

        if (now > end) auctionStatus = AuctionLotStatusEnum.Completed;

        if (start < now && now < end) {
            if (hasExtensions) {
                auctionStatus = AuctionLotStatusEnum.Extended;
            } else {
                auctionStatus = AuctionLotStatusEnum.Open;
            }
        }

        /* if (now < start) auctionStatus = AuctionLotStatusEnum.Awaiting;
     
        if (now > end) auctionStatus = AuctionLotStatusEnum.Completed;
      
        if (start < now && now < end) {
          if (hasExtensions) {
            auctionStatus = AuctionLotStatusEnum.Extended;
            alert("Hello")
          } else {
            auctionStatus = AuctionLotStatusEnum.Open;
          }
        } */

        return (
            <List>
                <ListItem>
                    <h5 className="text-primary font-weight-bold">
                        {AuctionLotStatusEnum[auctionStatus.toString()]} -{" "}
                        {auctionStatus === AuctionLotStatusEnum.Awaiting && (
                            <span className="text-black font-weight-normal">
                                {"This " +
                                    settings.AuctionName.toLowerCase() +
                                    " hasn't opened yet, but you need to register if you want to " +
                                    placeholderText +
                                    " when it does"}
                            </span>
                        )}
                        {(auctionStatus === AuctionLotStatusEnum.Open || auctionStatus === AuctionLotStatusEnum.Extended) && (
                            <span className="text-black font-weight-normal">
                                {"This " +
                                    settings.AuctionName.toLowerCase() +
                                    " is open for you to " +
                                    placeholderText +
                                    " on " +
                                    settings.LotName.toLowerCase() +
                                    "s if you have registered and been approved"}
                            </span>
                        )}
                        {auctionStatus === AuctionLotStatusEnum.Extended && (
                            <span className="text-black font-weight-normal">
                                {"This " +
                                    settings.AuctionName.toLowerCase() +
                                    " has been extended due to " +
                                    placeholderActioningText +
                                    " activity, " +
                                    placeholderActioningText +
                                    " is still open on certain " +
                                    settings.LotName.toLowerCase() +
                                    "s"}
                            </span>
                        )}
                        {auctionStatus === AuctionLotStatusEnum.Completed && (
                            <span className="text-black font-weight-normal">
                                {"This " +
                                    settings.AuctionName.toLowerCase() +
                                    " has completed and " +
                                    placeholderActioningText +
                                    " is closed"}
                            </span>
                        )}
                    </h5>
                </ListItem>
                <ListItem>
                    <h5 className="text-primary font-weight-bold">
                        {AuctionTypeEnum[auctionType.toString()]} -{" "}
                        {Number(auctionType) === Number(AuctionTypeEnum.Timed) && (
                            <span className="text-black font-weight-normal">
                                {"Start " +
                                    placeholderActioningText +
                                    " at the opening " +
                                    placeholderText +
                                    " in increments. The highest " +
                                    placeholderText +
                                    " is the winner at the end of the " +
                                    settings.AuctionName.toLowerCase() +
                                    ". Note: This is binding if your " +
                                    placeholderText +
                                    " is accepted"}
                            </span>
                        )}
                        {Number(auctionType) === Number(AuctionTypeEnum.Streamed) && (
                            <span className="text-black font-weight-normal">
                                {"Allowing you to watch a live stream of an onsite " +
                                    settings.AuctionName.toLowerCase()}
                            </span>
                        )}
                        {Number(auctionType) === Number(AuctionTypeEnum.Tender) && (
                            <span className="text-black font-weight-normal">
                                {
                                    "Submit a single confidential Tender. Note: This is binding if your tender is accepted"
                                }
                            </span>
                        )}
                    </h5>
                </ListItem>
                <ListItem>
                    <h5 className="text-primary font-weight-bold">
                        Registration Deposit -{" "}
                        <span className="text-black font-weight-normal">
                            {"The amount held as a deposit to register to " +
                                placeholderText +
                                ". The deposit is "}
                            <span className="text-danger font-weight-bold">
                                FULLY REFUNDABLE{" "}
                            </span>
                            {"if you are unsuccessful"}
                        </span>
                    </h5>
                </ListItem>
            </List>
        );
    };

    return (
        <AuctionCard
            imgSrc={imgSrc}
            title={header}
            description={description}
            auctionType={auctionType}
            depositAmount={infoBadgeText}
            startDateTimeAt={startDateTimeAt}
            endDateTimeAt={endDateTimeAt}
            auctionEndDateTimeAt={auctionEndDateTimeAt}
            onInfoClick={handleInfoPopperClick}
            infoPopper={anchorEl && <GeneralPopper headerText={"Info"} anchorEl={anchorEl} element={getInfoElement()} handleGeneralPopperClose={handleInfoPopperClose} />}
            onOpen={btnRoute}
            actions={btnText && <button type="button" className="pb-btn pb-btn-ink" onClick={btnRoute}>{btnText}</button>}
        />
    );
};

export default AuctionStackedCard;
